export const CREATE_API = "CREATE_API";
export const REMOVE_API = "REMOVE_API";
export const CREATE_MODEL = "CREATE_MODEL";
export const REMOVE_MODEL = "REMOVE_MODEL";
export const UPDATE_MODEL = "UPDATE_MODEL";
export const VIEW_API_LIST = "VIEW_API_LIST";
export const VIEW_API = "VIEW_API";
